module.exports = {
  createSavedSearch: require('./createSavedSearch.json'),
};
